import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 600,
      backgroundColor: palette.background.underBox,
      color: palette.text.darker,
      border: 'none',
      height: '30px',
      width: 'auto',
      borderRadius: palette.borderRadius.default,
      cursor: 'pointer',
      padding: '6px 10px 6px 10px',
      borderRight: '10px solid transparent',
      '&:focus': {
        outline: 'none'
      }
    },
    reporting: {
      fontWeight: 500,
      backgroundColor: palette.common.white,
      color: palette.text.secondary,
      fontSize: '16px',
      height: '40px',
      boxShadow: palette.shadows.boxShadow
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
